import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './FormStyles.css';

// Esquema de validación con Yup, ahora con Estado y Fecha de Nacimiento
const validationSchema = Yup.object({
  nombre: Yup.string().required('Nombre es requerido'),
  apellido: Yup.string().required('Apellido es requerido'),
  correo: Yup.string().email('Correo inválido').required('Correo es requerido'),
  telefono: Yup.string().required('Teléfono es requerido'),
  estado: Yup.string().required('Estado es requerido'),
  fechaNacimiento: Yup.string()
    .matches(/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/, 'Formato inválido (MM/DD/YYYY)')
    .required('Fecha de nacimiento es requerida'),
});

const Formulario = ({ onSubmit }) => (
  <Formik
    initialValues={{
      nombre: '',
      apellido: '',
      correo: '',
      telefono: '',
      estado: '',
      fechaNacimiento: '',
    }}
    validationSchema={validationSchema}
    onSubmit={(values, { setSubmitting }) => {
      onSubmit(values);
      setSubmitting(false);
    }}
  >
    {({ isSubmitting }) => (
      <Form className="form-container fade-in">
        <div className="form-group">
          <label htmlFor="nombre">Nombre</label>
          <Field name="nombre" type="text" />
          <ErrorMessage name="nombre" component="div" className="error" />
        </div>

        <div className="form-group">
          <label htmlFor="apellido">Apellido</label>
          <Field name="apellido" type="text" />
          <ErrorMessage name="apellido" component="div" className="error" />
        </div>

        <div className="form-group">
          <label htmlFor="correo">Correo</label>
          <Field name="correo" type="email" />
          <ErrorMessage name="correo" component="div" className="error" />
        </div>

        <div className="form-group">
          <label htmlFor="telefono">Teléfono</label>
          <Field name="telefono" type="text" />
          <ErrorMessage name="telefono" component="div" className="error" />
        </div>

        <div className="form-group">
          <label htmlFor="estado">Estado</label>
          <Field name="estado" type="text" />
          <ErrorMessage name="estado" component="div" className="error" />
        </div>

        <div className="form-group">
          <label htmlFor="fechaNacimiento">Fecha de Nacimiento</label>
          <Field name="fechaNacimiento" type="text" placeholder="MM/DD/YYYY" />
          <ErrorMessage name="fechaNacimiento" component="div" className="error" />
        </div>

        <button type="submit" disabled={isSubmitting} className="submit-button">
          {isSubmitting ? (
            <>
              <div className="spinner"></div>
              <span className="loader-text">
                Estamos validando tu información, pronto verás nuestro contenido
              </span>
            </>
          ) : (
            'Continuar'
          )}
        </button>
      </Form>
    )}
  </Formik>
);

export default Formulario;
